// extracted by mini-css-extract-plugin
module.exports = {"motif":"TableCellMotif_motif__2NqWH"};